import {Component, Input, OnInit} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-makery-event',
  templateUrl: './makery-event.component.html',
  styleUrls: ['./makery-event.component.scss']
})
export class MakeryEventComponent implements OnInit {

  @Input() event;
  selectedLanguage: any;
  constructor(private translate:TranslateService) {
    this.selectedLanguage = translate.currentLang;
  }

  ngOnInit() {
  }

}
